import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import {
  getContestReplyChildComment,
  postContestComment,
} from "../../../../../../redux/contest/action";
import { useParams } from "react-router-dom";
import { getPostsById } from "../../../../../../redux/posts/action";
export default function ContestCommentPost({
  setViewCommentID,
  item,
  commentid,
  setCommentID,
  posts,
}) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();
  const formik = useFormik({
    initialValues: {
      comment: "",
    },
    validationSchema: Yup.object({
      comment: Yup.string()
        .max(500, "Must be 500 characters or less")
        .required("Required"),
    }),
    onSubmit: (values, { resetForm }) => {
      submitform(values, resetForm);
    },
  });
  const submitform = (values, resetForm) => {
    const data = {
      message: values.comment,
      comment_id: item.id,
      type: 2,
      post_id: posts?.id,
    };
    dispatch(postContestComment(data, setLoading));
    // dispatch(getPostsById(id))
    // dispatch(getContestReplyChildComment(item.id));

    resetForm();
    setCommentID("");
    // setViewCommentID(0)
  };

  return (
    <div className="comment-input">
      <form onSubmit={formik.handleSubmit}>
        <input
          type="text"
          placeholder="Write a comment"
          className="form-control"
          id="comment"
          name="comment"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.comment}
        />
        {formik.touched.comment && formik.errors.comment ? (
          <div className="error" style={{ color: "red" }}>
            {formik.errors.comment}
          </div>
        ) : null}
        <div className="send-btn ">
          <button type="submit" className="btn">
            Send
          </button>
        </div>
      </form>
    </div>
  );
}
